/* Centauri C15 - optional proof track controls.
   This script never moves cards between C15 and C16; buyer review carousel behavior
   belongs to the C16 component. */
(function () {
  'use strict';

  var VERSION = '2026-07-02-singleton';

  if (window.CentauriC15ProPlayerProof && window.CentauriC15ProPlayerProof.version === VERSION) {
    window.CentauriC15ProPlayerProof.init(document);
    return;
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setupLineReveal(section) {
    if (!section || section.dataset.centauriLineRevealReady === 'true') return;
    section.dataset.centauriLineRevealReady = 'true';

    function reveal() {
      section.classList.add('is-line-revealed');
    }

    if (reduceMotion() || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (!entries[i].isIntersecting) continue;
        reveal();
        observer.disconnect();
        break;
      }
    }, { rootMargin: '0px 0px -18% 0px', threshold: 0.16 });

    observer.observe(section);
    section.__centauriLineRevealObserver = observer;
  }

  function stepFor(track) {
    var card = track.querySelector('.centauri-c15-pro-player-proof__item');
    if (!card) return Math.round(track.clientWidth * 0.85);
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return Math.round(card.getBoundingClientRect().width + gap);
  }

  function setup(root) {
    var section = root && root.closest ? root.closest('.centauri-c15-pro-player-proof') : null;
    setupLineReveal(section);

    if (root.dataset.centauriProofReady === 'true') return;

    var track = root.querySelector('[data-centauri-proof-track]');
    var nav = root.querySelector('[data-centauri-proof-nav]');
    if (!track || !nav) return;

    var prev = nav.querySelector('[data-centauri-proof-prev]');
    var next = nav.querySelector('[data-centauri-proof-next]');
    var scheduled = false;

    function scrollByDirection(direction) {
      track.scrollBy({
        left: stepFor(track) * direction,
        behavior: reduceMotion() ? 'auto' : 'smooth'
      });
    }

    function setButton(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function refresh() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 1;
      if (scrollable) nav.removeAttribute('hidden');
      else nav.setAttribute('hidden', '');

      setButton(prev, !scrollable || track.scrollLeft <= 1);
      setButton(next, !scrollable || track.scrollLeft >= max - 1);
    }

    function scheduleRefresh() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        refresh();
      });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDirection(-1); });
    if (next) next.addEventListener('click', function () { scrollByDirection(1); });
    track.addEventListener('scroll', scheduleRefresh, { passive: true });
    window.addEventListener('resize', scheduleRefresh, { passive: true });

    root.__centauriProofTeardown = function () {
      window.removeEventListener('resize', scheduleRefresh);
      delete root.__centauriProofTeardown;
    };

    refresh();
    root.dataset.centauriProofReady = 'true';
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-centauri-proof-root]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  function unload(scope) {
    var roots = (scope || document).querySelectorAll('[data-centauri-proof-root]');
    for (var i = 0; i < roots.length; i++) {
      if (typeof roots[i].__centauriProofTeardown === 'function') {
        roots[i].__centauriProofTeardown();
      }
      var section = roots[i].closest ? roots[i].closest('.centauri-c15-pro-player-proof') : null;
      if (section && section.__centauriLineRevealObserver) {
        section.__centauriLineRevealObserver.disconnect();
        delete section.__centauriLineRevealObserver;
      }
    }
  }

  window.CentauriC15ProPlayerProof = {
    version: VERSION,
    init: init,
    unload: unload
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    init(event.target || document);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    unload(event.target);
  });
})();
